module.exports = __webpack_public_path__ + "media/images/pic/team_contact_default-6c117157350e020673da0a9a8cc43021.svg";